export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13660.2d15044f.jpg";